import { Box } from '@mui/material'
import { useSettingsEditing } from '../../hooks/useSettingsEditing'

import { PersonalizationForm } from './PersonalizationForm'
import { PersonalizationView } from './PersonalizationView'

export function Personalization() {
  const { editing, onEdit, onDiscard } = useSettingsEditing('personalization', 'reset')

  return (
    <Box display="flex" width="100%" height="100%" data-testid="personalization-root">
      {!editing && <PersonalizationView onEdit={onEdit} />}
      {editing && <PersonalizationForm onDiscard={onDiscard} />}
    </Box>
  )
}
